import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Analytics } from '@vercel/analytics/react'
import { SpeedInsights } from "@vercel/speed-insights/react"
import * as Sentry from '@sentry/react'
import './index.css'
import './i18n'
import App from './App'

// Initialize Sentry for error tracking (only in production with DSN)
const sentryDsn = import.meta.env.VITE_SENTRY_DSN

if (sentryDsn) {
    Sentry.init({
        dsn: sentryDsn,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                // Mask all text and block all media by default for privacy
                maskAllText: false,
                blockAllMedia: false,
            }),
        ],
        // Performance monitoring - sample 10% of transactions
        tracesSampleRate: 0.1,
        // Session Replay - capture 100% of sessions with errors
        replaysOnErrorSampleRate: 1.0,
        // Capture 10% of all sessions (for general monitoring)
        replaysSessionSampleRate: 0.1,
        // Environment tag
        environment: import.meta.env.MODE,
        // Enable debug mode in development to see logs in console
        //debug: import.meta.env.DEV,
    })
}

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Root element not found')

createRoot(rootElement).render(
    <StrictMode>
        <App />
        <Analytics />
        <SpeedInsights />
    </StrictMode>
)
